<template>
<div class="chapter">
<div class="inner_page">
<figure class="img_container4" id="fig1"><a id="page_2">
<img alt="" src="images/pg2.jpg"/>
<p class="figcaption">The Crown of Victory</p>
</a></figure><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Fm02.vue?378af587